import { MailRowDataPropertyGetter } from 'owa-mail-list-store';
export default {
    mailListRetryClicked: {
        datapoint: {
            name: 'TnS_RetryLoadMailListClicked',
        },
    },
    SelectMailItemDatapoint: {
        datapoint: {
            name: 'SelectMailItem',
            options: { isQos: true },
            customData: function (tableView, rowKey, isUserNavigation, mailListItemSelectionSource) {
                var validCouponIndexes = MailRowDataPropertyGetter.getValidCouponIndexes(rowKey, tableView);
                return [
                    mailListItemSelectionSource,
                    tableView.tableQuery.listViewType,
                    tableView.tableQuery.type,
                    tableView.tableQuery.type === 1 /* Search */ &&
                        tableView.tableQuery.searchScope.kind,
                    validCouponIndexes ? validCouponIndexes.length : 0,
                ];
            },
        },
    },
};
//# sourceMappingURL=datapoints.js.map